import React from 'react';

const FacebookIcon = ({ className, fill = '#fff' }) => {
    return (
        <svg width={8} height={15} viewBox="0 0 8 15" className={className}>
            <path
                d="M8 2.43H6.52c-1.202 0-1.355.764-1.355 1.362v1.65H7.83l-.333 2.664h-2.33V15H2.361V8.106H0V5.442h2.362V3.194C2.362.92 4.312 0 5.473 0H8v2.43z"
                fill={fill}
                fillRule="evenodd"
            />
        </svg>
    );
};

export default FacebookIcon;
